const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-train');
const Form = resolve => require.ensure([], () => resolve(require('./Form.vue')), 'group-train');
const Entries = resolve => require.ensure([], () => resolve(require('./Entries.vue')), 'group-train');
const Logs = resolve => require.ensure([], () => resolve(require('./Logs.vue')), 'group-train');
const Tasks = resolve => require.ensure([], () => resolve(require('./Tasks.vue')), 'group-train');

export default [{
  path: '/admin/train/activities',
  name: 'admin_train_activity_index',
  component: Index,
  meta: {
    title: '培训项目',
    layout: 'admin',
  },
}, {
  path: '/admin/train/activities/new',
  name: 'admin/train/activities/new',
  component: Form,
  meta: {
    title: '新建项目',
    layout: 'admin',
  },
}, {
  path: '/admin/train/activities/:id/edit',
  name: 'admin/train/activities/edit',
  component: Form,
  meta: {
    title: '更新项目',
    layout: 'admin',
  },
}, {
  path: '/admin/train/activities/:id/entries',
  name: 'admin_train_activities_entry_index',
  component: Entries,
  meta: {
    title: '报名列表',
    layout: 'admin',
  },
},
{
  path: '/admin/train/activities/:id/logs',
  name: 'admin_train_activities_log_index',
  component: Logs,
  meta: {
    title: '日志列表',
    layout: 'admin',
  },
}, {
  path: '/admin/train/activities/:id/tasks',
  name: 'admin_train_activities_task_index',
  component: Tasks,
  meta: {
    title: '作业列表',
    layout: 'admin',
  },
}];



// WEBPACK FOOTER //
// ./src/pages/admin/train/activity/index.js